module.exports = __webpack_public_path__ + "static/how-to-pay-4-a87977c510abb12d496c79e2c7d5274c.png";